import { render, staticRenderFns } from "./generic_card_element.vue?vue&type=template&id=529ab8cb&"
import script from "./generic_card_element.vue?vue&type=script&lang=js&"
export * from "./generic_card_element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports